<div class="calendar-header">
    <button
        mat-icon-button
        class="nav-btn left"
        [disabled]="!previousEnabled()"
        (click)="previousClicked()"
    >
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>

    <div class="header-label">
        <button mat-button class="header-label-btn month" (click)="onMonthClick()">
            {{ activeMonth }}
        </button>
        <button mat-button class="header-label-btn" (click)="onYearClick()">
            {{ activeYear }}
        </button>
    </div>

    <button
        mat-icon-button
        class="nav-btn right"
        [disabled]="!nextEnabled()"
        (click)="nextClicked()"
    >
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
